// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bCbReunzexwCrvD617Yl{margin-bottom:4px}`, "",{"version":3,"sources":["webpack://./src/shared/ui/Dropdown/ui/DropdownPlaceholder/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA","sourcesContent":[".error {\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `bCbReunzexwCrvD617Yl`
};
export default ___CSS_LOADER_EXPORT___;
